<template>
  <div class="content-wrapper">
    <HeaderBar
      view="save"
      :showBar="showHeaderBar"
      @discard="discardModalOpen = true"
      @save="saveChanges($route.params.name)"
    />
    <BackButton
      link="/agency/our-directory/manage-partners"
      text="Back to Manage partners"
    />
    <ProfileHeading
      :heading="profileData.companyName"
      :main-badge="{
        text: badgeStatusFilter('status'),
        class: badgeStatusFilter('statusClass'),
      }"
      :profile-link="{
        href: profileLink,
        text: profileData.status === 'H' ? 'Preview profile' : 'View profile',
        showPreviewIcon:
          profileData.status === 'H' || profileData.status === 'N',
      }"
    />
    <Card>
      <div class="grid">
        <div class="grid__cell col6-of-12--medium-up">
          <Select
            :options="statusOptions"
            :selected="profileData.status"
            label="Status"
            @input-change="updateStatus"
          />
        </div>
      </div>
    </Card>
    <hr margin="2rem 0" />
    <AboutContentSection
      namespace="managePartnersDetail"
      :managePartners="true"
    />
    <QuoteContentSection
      namespace="managePartnersDetail"
      @delete-content="deleteContent"
    ></QuoteContentSection>
    <UseCaseContentSection
      namespace="managePartnersDetail"
      @delete-content="deleteContent"
    />
    <ResourcesContentSection
      namespace="managePartnersDetail"
      @delete-content="deleteContent"
    />
    <CTAContentSection
      namespace="managePartnersDetail"
      @url-error="
        handleUrlError(
          'button',
          'Button',
          $event,
          'Please fill out the Call to action section completely'
        )
      "
    />

    <CategoriesContentSection
      v-if="profileData.allCategories && profileData.allCategories.length > 0"
      namespace="managePartnersDetail"
      :categories="profileData.allCategories"
      :profile-categories="profileData.categories"
    />

    <div class="button-wrapper">
      <Button v-on:button-click="saveChanges($route.params.name)" type="button">
        Save
      </Button>
    </div>
    <DSModal
      v-if="modalOpen"
      :old="false"
      :newButtons="true"
      :modalShowing="true"
      :title="modalOpen.title"
      :description="modalOpen.description"
      @close-modal="modalOpen = false"
      @primary-click="confirmedDelete"
      @secondary-click="modalOpen = false"
    />
    <DSModal
      v-if="discardModalOpen"
      :old="false"
      :newButtons="true"
      :modalShowing="true"
      title="Discard changes?"
      description="Are you sure you want to discard all the changes?"
      @close-modal="discardModalOpen = false"
      primaryText="Discard changes"
      secondaryText="Cancel"
      @primary-click="discardChanges"
      @secondary-click="discardModalOpen = false"
    />
  </div>
</template>

<script>
import HeaderBar from '@/components/DesignSystem/HeaderBar';
import Card from '@/components/DesignSystem/Card.vue';
import CategoriesContentSection from '@/components/Shared/ContentSection/CategoriesContentSection';
import AboutContentSection from '@/components/Shared/ContentSection/AboutContentSection';
import QuoteContentSection from '@/components/Shared/ContentSection/QuoteContentSection';
import ResourcesContentSection from '@/components/Shared/ContentSection/ResourcesContentSection';
import CTAContentSection from '@/components/Shared/ContentSection/CTAContentSection';
import UseCaseContentSection from '@/components/Shared/ContentSection/UseCaseContentSection';
import BackButton from '@/components/BackButton';
import Select from '@/components/DesignSystem/Inputs/Select';
import { filtersOptions } from '@/views/Dashboard/OurPublicProfiles/FiltersOptions';
import { removeDoubleBackslash } from '@/store/vendorDashboard/getters';
import Button from '@/components/DesignSystem/Button';
import DSModal from '@/components/DesignSystem/Modal';
import { createNamespacedHelpers } from 'vuex';
import ProfileHeading from '@/components/Shared/ContentSection/ProfileHeading';
const { mapGetters, mapActions } = createNamespacedHelpers(
  'managePartnersDetail'
);

export default {
  components: {
    ProfileHeading,
    Card,
    Select,
    AboutContentSection,
    CategoriesContentSection,
    DSModal,
    UseCaseContentSection,
    QuoteContentSection,
    CTAContentSection,
    HeaderBar,
    Button,
    BackButton,
    ResourcesContentSection,
  },
  data() {
    return {
      discardModalOpen: false,
      modalOpen: false,
      toDelete: undefined,
      deleteType: undefined,
    };
  },
  filters: {
    ...filtersOptions,
  },
  methods: {
    removeDoubleBackslash,
    ...mapActions([
      'clearPartner',
      'saveChanges',
      'updateStatus',
      'fetchProfile',
      'fetchUseCases',
      'fetchQuotes',
      'fetchResources',
      'fetchButton',
    ]),
    confirmedDelete() {
      if (this.deleteType === 'testimonials') {
        this.$store.dispatch(
          'managePartnersDetail/deleteItemForTestimonial',
          this.toDelete
        );
      }

      if (this.deleteType === 'resources') {
        this.$store.dispatch(
          'managePartnersDetail/deleteItemForResources',
          this.toDelete
        );
      }

      if (this.deleteType === 'useCases') {
        this.$store.dispatch(
          'managePartnersDetail/deleteItemForUseCases',
          this.toDelete
        );
      }

      this.modalOpen = false;
      this.toDelete = false;
    },
    fetchData() {
      this.fetchProfile(this.$route.params.name);
      this.fetchUseCases(this.$route.params.name);
      this.fetchQuotes(this.$route.params.name);
      this.fetchResources(this.$route.params.name);
      this.fetchButton(this.$route.params.name);
    },
    discardChanges() {
      this.fetchData();
      this.discardModalOpen = false;
    },

    deleteContent(payload) {
      this.toDelete = payload;
      this.modalOpen = {
        title: payload.modalTitle,
        description: payload.modalDescription,
      };
      this.deleteType = payload.section;
    },
    handleUrlError(key, label, value, message) {
      this.$store.commit('managePartnersDetail/setError', {
        key,
        label,
        state: value,
        message,
      });
    },
    badgeStatusFilter(filter) {
      return this.$options.filters[filter](this.profileData.status);
    },
  },
  created() {
    this.fetchData();
  },
  computed: {
    ...mapGetters(['profileData', 'showHeaderBar']),
    vendor() {
      return this.$route.params.name;
    },
    statusOptions() {
      return [
        { name: 'Public', value: 'P' },
        { name: 'Public - Featured', value: 'F' },
        { name: 'Searchable', value: 'S' },
        { name: 'Hidden', value: 'H' },
      ];
    },
    profileLink() {
      let url = '';
      const genericDomain =
        'https://' +
        this.profileData.directoryPartnerpageUrl +
        '.partnerpage.io';
      const directoryPage = this.$store.state[''].settings.directoryPage;
      if (this.profileData.status === 'H' || this.profileData.status === 'N') {
        url = genericDomain;
        if (directoryPage) {
          url += '/' + directoryPage;
        }
        url +=
          '/preview/' + this.profileData.vendorSlug + '/' + this.profileData.id;
      } else {
        url = this.profileData.directoryCustomDomain
          ? this.profileData.directoryCustomDomain
          : genericDomain;

        if (directoryPage) {
          url += '/' + directoryPage;
        }
        url += '/' + this.profileData.vendorSlug;
      }
      return this.removeDoubleBackslash(url);
    },
  },
  beforeRouteLeave(to, from, next) {
    this.clearPartner();
    next();
  },
};
</script>

<style lang="scss" scoped>
a {
  color: #6d7175;
}

.button-wrapper {
  display: flex;
  justify-content: flex-end;
  margin: 2rem 0;
}

.content-wrapper {
  margin: 0 auto 5rem;
  max-width: 960px;
}

.route-enter-active,
.route-leave-active {
  transition-duration: 0.1s;
  transition-property: all;
  transition-timing-function: ease;
}

.route-enter-active {
  transition-delay: 0.1s;
}

.route-enter,
.route-leave-active {
  opacity: 0;
}
</style>
